<template>
  <q-page padding>
    <q-form @submit="onSubmit">
      <lwf-card-list
        :items="value"
        title="Catalogue d'articles"
        class="col-12"
        @ajouter="addRow"
      >
        <template #item="scope">
          <item-agency-catalog-service
            :key="scope.item.id || scope.item._id"
            :item="scope.item"
          >
            <template #side>
              <q-item-section side>
                <q-btn
                  icon="fa fa-trash"
                  flat
                  round
                  @click="value.splice(scope.index, 1)"
                />
              </q-item-section>
            </template>
          </item-agency-catalog-service>
        </template>
      </lwf-card-list>
      <lwf-form-submit />
    </q-form>
  </q-page>
</template>

<script>
import LwfCardList from 'components/core/LwfCardList'
import ItemAgencyCatalogService from 'components/Item/ItemAgencyCatalogService'
import ParamsAgencyMixin from 'pages/Platform/Params/ParamsAgencyMixin'
import LwfFormSubmit from 'components/core/LwfFormSubmit'

export default {
  name: 'ParamsAgencyCatalogServices',
  components: { LwfFormSubmit, ItemAgencyCatalogService, LwfCardList },
  mixins: [ParamsAgencyMixin],
  data () {
    return {
      addId: 0
    }
  },
  computed: {
    value () {
      return this.agency.catalogServices
    }
  },
  methods: {
    addRow () {
      this.value.unshift({
        _id: --this.addId,
        specialties: []
      })
    }
  }
}
</script>
